import { PauseCircleOutlined, SwapOutlined } from "@ant-design/icons";
import CustomTag from "./CustomTag";
import React from "react";
import AugerDTO from "src/models/AugerDTO";
import DryingOperationsSettingsDTO from "src/models/DryingOperationsSettingsDTO";

interface AugerStatusTagProps{
    augers: AugerDTO[] | null | undefined;
}

const AugerStatusTag : React.FC<AugerStatusTagProps> = ({ augers }) => {

    if(augers?.find( a => a?.isOn === true) != null){
        return(
            <CustomTag label={'Auger(s): ON'} icon={<SwapOutlined />} color={'green'}/> 
        )
    }

    return(
        <CustomTag label={'Auger(s): OFF'} icon={<SwapOutlined />} color={'red'}/> 
    )

}

export default AugerStatusTag;